import {VariantConfigT} from '@/lib/types/colors.types';

export const redConfig: VariantConfigT = {
  basic: {
    icon: 'red',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'red',
    active: 'red',
  },
  outline: {
    icon: 'red',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'red',
    iconHover: 'red',
    iconActive: 'red',
    hover: 'red',
    active: 'red',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
